<template>
  <div class="product-list-page">
    <div class="top-title">
      <img class="de-img logo" :src="logo" alt="功夫好车x剁手狂欢节" />
      <img class="de-img title" :src="title" alt="0首付限时秒杀最高立省13000元" />
      <span class="de-img time-range">活动时间：11月1日-11月8日</span>
      <div class="rules-btn" @click="rulesShow = true">活动规则</div>
    </div>
    <div class="product-list">
      <div class="list-wrap" v-for="(type, index) in  carList" :key="index">
        <img class="subtitle" :src="type.title" />
        <template v-if="type.list.length % 2 !== 0">
          <div class="single-card">
            <img class="badge" :src="badge" alt="0首付">
            <img class="car-img" :src="type.list[0].imgUrl" :alt="type.list[0].title">
            <button class="btn-buy" @click="goBuy(type.list[0].productId)" :disabled="throttleClick"></button>
          </div>
          <div class="double-wrap">
            <div class="double-card" v-for="item in type.list.slice(1)" :key="item.productId">
              <img class="badge" :src="badge" alt="0首付">
              <img class="car-img" :src="item.imgUrl" :alt="item.title">
              <button class="btn-buy" @click="goBuy(item.productId)" :disabled="throttleClick"></button>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="double-wrap">
            <div class="double-card" v-for="item in type.list" :key="item.productId">
              <img class="badge" :src="badge" alt="0首付">
              <img class="car-img" :src="item.imgUrl" :alt="item.title">
              <button class="btn-buy" @click="goBuy(item.productId)" :disabled="throttleClick"></button>
            </div>
          </div>
        </template>
      </div>
    </div>
    <p class="tip-text">更多活动欢迎进店咨询～</p>
    <!--活动规则弹窗-->
    <div class="rules" v-if="rulesShow">
      <div class="rules-toast">
        <p class="rules-title">活动规则</p>
        <div class="rules-content">
          <p>1、活动时间：</p>
          <p>2019年11月1日00:00:00-2019年11月8日23:59:59</p>
          <p>2、活动规则：</p>
          <p>1）用户在活动期间可参与抢购0首付资格优惠券，每个登录ID仅限抽取到1张“0首付资格优惠券”，同一手机号、身份证号、终端设备等均视为同一用户条件。</p>
          <p>2）用户抢购“0首付资格优惠券”成功后的5分钟内需支付500元定金占用名额，否则视为自愿放弃，同时我司有权将对应优惠券重新释放给广大用户。</p>
          <p>3）0首付资格优惠券为指定车型优惠券，具体车型、以及所在区域通过活动页面展示，用户选购0首付汽车时需仔细查看车型和区域是否符合用户需求；优惠车辆数量有限，抢完即止，详情还可咨询销售经理。</p>
          <p>4）上述优惠券使用期限为2019年11月1日-2019年11月11日。</p>
          <p>5）用户须在上述优惠券的使用期限内以我司规定的金融方案与我司签署《汽车融资租赁合同》，使用0首付资格优惠券的用户选购0首付车型需缴纳一定的保证金，例如赛欧新车需缴纳3000元作为保证金（该保证金在用户还款钱6个月分500元抵扣租金），具体金额请咨询门店销售经理。本券不适于全款购车方案。</p>
          <p>6）本活动最终解释权归功夫好车所有，用户参加本活动即视为用户同意本活动规则。用户理解并同意，在不损害用户实际利益的情况下，我司可根据实际情况对本活动内容进行修改，包括暂停或终止本活动；</p>
        </div>
        <div class="iknow" @click="closeToast">知道了</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getShuang11CarList, shuang11Buy } from '@/views/pages/app/api/index';
import title from './imgs/title.png';
import popular from './imgs/popular.png';
import button from './imgs/button.png';
import newcar from './imgs/newcar.png';
import logo from './imgs/logo.png';
import badge from './imgs/badge.png';
export default {
  name: 'productsList',
  data () {
    return {
      title,
      popular,
      button,
      logo,
      badge,
      throttleClick: false,
      token: sessionStorage.getItem('DEtoken') || '',
      rulesShow: false, // 活动规则弹框
      tipVisible: true,
      carList: [
        {
          title: popular,
          list: []
        },
        {
          title: newcar,
          list: []
        }
      ],
      carId: null
    };
  },
  created () {
    this.queryList();
  },
  methods: {
    // 关闭弹窗
    closeToast () {
      this.rulesShow = false;
    },
    async queryList () {
      try {
        const res = await getShuang11CarList({ token: this.token });
        if (res.data.errcode !== 'SUCCESS') {
          this.$toast(res.data.msg);
          return;
        }
        this.carList[0].list = res.data.data.filter(item => item.tag === 'newCar') || [];
        this.carList[1].list = res.data.data.filter(item => item.tag === 'oldCar') || [];
      } catch (e) {
        this.$toast(e.response.status + '错误');
      }
    },
    async goBuy (id) {
      try {
        this.throttleClick = true;
        const res = await shuang11Buy({ token: this.token, productId: id });
        this.throttleClick = false;
        if (res.data.errcode !== 'SUCCESS') {
          this.$toast(res.data.msg);
          return;
        }
        sessionStorage.setItem('DEjnlId', res.data.data.jnlId);
        // this.$router.push('/pay/doubleEleven');
        window.location.href = `${window.location.origin}/pay/doubleEleven`;
      } catch (e) {
        this.throttleClick = false;
        this.$toast(e.response.status + '错误');
      }
    }
  }
};
</script>

<style scoped lang="scss">
  .product-list-page {
    background-color: rgba(247,67,68,1);
    min-height: 100vh;
    background-image: url("./imgs/loginbg.png");
    background-size: 100%;
    padding-top: 515px;
    .top-title {
      width: 100%;
      height: 580px;
      background: url("./imgs/topbg.png") no-repeat;
      background-size: 100% 100%;
      text-align: center;
      position: absolute;
      top: 0px;
      .de-img {
        display: block;
        position: absolute;
      }
      .logo {
        width: 313px;
        height: 54px;
        top: 52px;
        left: 219px;
      }
      .title {
        width: 580px;
        height: 166px;
        top: 125px;
        left: 92px;
      }
      .time-range {
        bottom: 117px;
        left: 213px;
        font-size:23px;
        font-family:Alibaba PuHuiTi;
        font-weight:500;
        color:rgba(255,255,250,1);
      }
      .rules-btn {
        position: absolute;
        right: 0;
        bottom: 20px;
        width:134px;
        height:48px;
        box-sizing: border-box;
        padding-left: 12px;
        background:rgba(255,212,96,1);
        border-radius: 28px 0 0 28px;
        font-size: 26px;
        line-height: 50px;
        font-family:PingFang SC;
        font-weight:600;
        color:rgba(222,42,41,1);
        background:linear-gradient(181deg,rgba(255,255,255,1),rgba(255,248,200,1));
        box-shadow:0px 9px 15px 3px rgba(135,13,25,1);
      }
    }
    .product-list {
      .list-wrap {
        box-sizing: border-box;
        padding: 0 33px;
        .subtitle {
          display: block;
          width: 204px;
          height: 48px;
          margin: 0 auto 30px;
        }
        .single-card {
          width: 679px;
          height: 232px;
          border-radius:12px;
          background:linear-gradient(181deg,rgba(255,255,255,1),rgba(255,248,200,1));
          margin: 0px auto 42px;
          position: relative;
          box-shadow:0px 9px 15px 3px rgba(135,13,25,1);
          .badge {
            display: block;
            width: 107px;
            height: 107px;
            position: absolute;
            right: 5px;
            top: -45px;
          }
          .car-img {
            width: 100%;
            height: 100%;
            border-radius:12px;
          }
          .btn-buy {
            position: absolute;
            width:141px;
            height:46px;
            background: url("./imgs/button.png") no-repeat;
            background-size: 100% 100%;
            left: 184px;
            bottom: 25px;
          }
        }
        .double-wrap {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          .double-card {
            width: 322px;
            height: 421px;
            border-radius:12px;
            background:linear-gradient(181deg,rgba(255,255,255,1),rgba(255,248,200,1));
            position: relative;
            box-shadow:0px 9px 15px 3px rgba(135,13,25,1);
            margin: 0px 0 42px;
            .badge {
              display: block;
              width: 107px;
              height: 107px;
              position: absolute;
              left: -18px;
              top: -28px;
            }
            .car-img {
              width: 100%;
              height: 100%;
              border-radius:12px;
            }
            .btn-buy {
              position: absolute;
              width:141px;
              height:46px;
              background: url("./imgs/button.png") no-repeat;
              background-size: 100% 100%;
              right: 25px;
              bottom: 25px;
            }
          }
        }
      }
    }
    .tip-text {
      text-align: center;
      font-size:30px;
      font-family:Alibaba PuHuiTi;
      font-weight:500;
      color: #FFFCE4;
      padding: 20px 0 57px;
    }
  }
  .tip {
    width: 600px;
  }
  .rules {
    position: fixed;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background: rgba(0,0,0, 0.6029);
    z-index: 100000;
    .rules-toast {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      width:556px;
      height:772px;
      background:linear-gradient(181deg,rgba(255,255,255,1),rgba(255,248,200,1));
      border-radius:30px;
      box-sizing: border-box;
      padding: 26px 37px 26px;
      text-align: center;
      p {
        font-size:22px;
        font-family:Alibaba PuHuiTi;
        color:rgba(255,69,69,1);
        font-weight:400;
        color:rgba(247,67,68,1);
        line-height: 32px;
      }
      .rules-title {
        font-size:36px;
        font-family:Alibaba PuHuiTi;
        font-weight:800;
        color:rgba(247,67,68,1);
        text-align: center;
      }
      .rules-content {
        height: 608px;
        font-size:24px;
        margin: 18px 0;
        overflow: scroll;
        text-align: left;
      }
      .iknow {
        width:141px;
        height:46px;
        font-size: 28px;
        line-height: 45px;
        color:rgba(255,255,250,1);
        background:linear-gradient(181deg,rgba(250,52,71,1),rgba(190,0,18,1));
        border-radius:23px;
        margin: 0 auto;
      }
    }
  }
</style>
